import { IconButton } from "../IconButton";
import { FaTimes } from "react-icons/fa";

export const Close = ({ onClick }: { onClick?(): void }) => {
  return <IconButton onClick={onClick} icon={FaTimes} />;
};
